<!-- Top Navigation Bar -->
<header class="top-navbar">
  <div class="logo-container">
    <img class="logo-icon" src="/assets/topbar-logo.svg" alt="Logo" />
  </div>
  <div class="login-section">
    <img class="login-icon" src="/assets/icons/login-icon.svg" alt="Login" />
    <span>Login</span>
  </div>
</header>

<!-- Main Layout -->
<div class="app-layout">
  <!-- Sidebar Navigation -->
  <app-sidebar></app-sidebar>

  <!-- Main Content Area -->
  <main class="main-container">
    <router-outlet />
  </main>
</div>

<!-- Footer -->
<footer class="app-footer">
  <div class="footer-logo">
    <img src="assets/astrazeneca-logo.svg" alt="AstraZeneca Logo" />
  </div>
  <div class="footer-info">
    <span
      >App Portal (version 1.0.0) is created and maintained by AZ IT
      #OneIT</span
    >
    <span>AstraZeneca 2025</span>
  </div>
</footer>
